{
  "MFA_SETTINGS": {
    "TITLE": "Autenticazione a Due Fattori",
    "SUBTITLE": "Proteggi il tuo account da accessi non autorizzati con l'autenticazione TOTP. Questa aggiunge un ulteriore livello di sicurezza al tuo account.",
    "DESCRIPTION": "Aggiungi un ulteriore livello di sicurezza al tuo account utilizzando una password monouso a tempo (TOTP)",
    "STATUS_TITLE": "Stato dell'Autenticazione",
    "STATUS_DESCRIPTION": "Gestisci le impostazioni di autenticazione a due fattori e i codici di recupero di backup",
    "ENABLED": "Abilitato",
    "DISABLED": "Disabilitato",
    "STATUS_ENABLED": "L'autenticazione a due fattori è attiva",
    "STATUS_ENABLED_DESC": "Il tuo account è protetto con un ulteriore livello di sicurezza",
    "ENABLE_BUTTON": "Attiva Autenticazione A Due Fattori",
    "ENHANCE_SECURITY": "Migliora La Sicurezza Del Tuo Account",
    "ENHANCE_SECURITY_DESC": "L'autenticazione a due fattori aggiunge un ulteriore livello di sicurezza richiedendo un codice di verifica dalla tua app di autenticazione in aggiunta alla password.",
    "SETUP": {
      "STEP_NUMBER_1": "1",
      "STEP_NUMBER_2": "2",
      "STEP1_TITLE": "Scansiona il QR Code con la tua app di autenticazione",
      "STEP1_DESCRIPTION": "Utilizza Google Authenticator, Authy, o qualsiasi app compatibile con TOTP",
      "LOADING_QR": "Caricamento...",
      "MANUAL_ENTRY": "Non riesci a scansionare? Inserisci il codice manualmente",
      "SECRET_KEY": "Chiave Segreta",
      "COPY": "Copia",
      "ENTER_CODE": "Inserisci il codice a 6 cifre dalla tua app di autenticazione",
      "ENTER_CODE_PLACEHOLDER": "000000",
      "VERIFY_BUTTON": "Verifica e Continua",
      "CANCEL": "Annulla",
      "ERROR_STARTING": "MFA non abilitata. Contatta l'amministratore.",
      "INVALID_CODE": "Codice di verifica non valido",
      "SECRET_COPIED": "Chiave segreta copiata negli appunti",
      "SUCCESS": "L'autenticazione a due fattori è stata attivata con successo"
    },
    "BACKUP": {
      "TITLE": "Salva i tuoi Codici Di Backup",
      "DESCRIPTION": "Mantieni questi codici al sicuro. Ognuno può essere utilizzato una sola volta se perdi l'accesso alla tua app di autenticazione",
      "IMPORTANT": "Importante:",
      "IMPORTANT_NOTE": " Salva questi codici in un luogo sicuro. Non sarai in grado di visualizzarli ancora.",
      "DOWNLOAD": "Scarica",
      "COPY_ALL": "Copia Tutto",
      "CONFIRM": "Ho salvato i miei codici di backup in un luogo sicuro e comprendo che non sarò in grado di visualizzarli ancora",
      "COMPLETE_SETUP": "Completa Configurazione",
      "CODES_COPIED": "Codici di backup copiati negli appunti"
    },
    "MANAGEMENT": {
      "BACKUP_CODES": "Codici di Backup",
      "BACKUP_CODES_DESC": "Genera nuovi codici se hai perso o utilizzato quelli esistenti",
      "REGENERATE": "Rigenera Codici di Backup",
      "DISABLE_MFA": "Disattiva 2FA",
      "DISABLE_MFA_DESC": "Rimuovi l'autenticazione a due fattori dal tuo account",
      "DISABLE_BUTTON": "Disattiva Autenticazione A Due Fattori"
    },
    "DISABLE": {
      "TITLE": "Disattiva Autenticazione A Due Fattori",
      "DESCRIPTION": "Dovrai inserire la tua password e un codice di verifica per disabilitare l'autenticazione a due fattori.",
      "PASSWORD": "Password",
      "OTP_CODE": "Codice Di Verifica",
      "OTP_CODE_PLACEHOLDER": "000000",
      "BACKUP_CODE": "Codice di Backup",
      "BACKUP_CODE_PLACEHOLDER": "Inserisci uno dei tuoi codici di backup",
      "USE_BACKUP_CODE": "Hai perso l'accesso al tuo sistema di autenticazione? Usa un codice di backup",
      "USE_OTP_CODE": "Usa un codice di verifica dalla tua app di autenticazione",
      "CONFIRM": "Disattiva 2FA",
      "CANCEL": "Annulla",
      "SUCCESS": "L'autenticazione a due fattori è stata disattivata",
      "ERROR": "Impossibile disattivare MFA. Verifica le tue credenziali."
    },
    "REGENERATE": {
      "TITLE": "Rigenera Codici di Backup",
      "DESCRIPTION": "Questo invaliderà i tuoi codici di backup esistenti e ne genererà di nuovi. Inserisci il tuo codice di verifica per continuare.",
      "OTP_CODE": "Codice Di Verifica",
      "OTP_CODE_PLACEHOLDER": "000000",
      "CONFIRM": "Genera Nuovi Codici",
      "CANCEL": "Annulla",
      "NEW_CODES_TITLE": "Nuovi Codici di Backup Generati",
      "NEW_CODES_DESC": "I tuoi vecchi codici di backup sono stati invalidati. Salva questi nuovi codici in un luogo sicuro.",
      "CODES_IMPORTANT": "Importante:",
      "CODES_IMPORTANT_NOTE": "Ogni codice può essere usato solo una volta. Salvali prima di chiudere questa finestra.",
      "DOWNLOAD_CODES": "Scarica Codici",
      "COPY_ALL_CODES": "Copia Tutti i Codici",
      "CODES_SAVED": "Ho Salvato i Miei Codici",
      "SUCCESS": "Nuovi codici di backup sono stati generati",
      "ERROR": "Impossibile rigenerare i codici di backup"
    }
  },
  "MFA_VERIFICATION": {
    "TITLE": "Autenticazione a Due Fattori",
    "DESCRIPTION": "Inserisci il tuo codice di verifica per continuare",
    "AUTHENTICATOR_APP": "App di Autenticazione",
    "BACKUP_CODE": "Codice di Backup",
    "ENTER_OTP_CODE": "Inserisci il codice a 6 cifre dalla tua app di autenticazione",
    "ENTER_BACKUP_CODE": "Inserisci uno dei tuoi codici di backup",
    "BACKUP_CODE_PLACEHOLDER": "000000",
    "VERIFY_BUTTON": "Verifica",
    "TRY_ANOTHER_METHOD": "Prova un altro metodo di verifica",
    "CANCEL_LOGIN": "Annulla e torna al login",
    "HELP_TEXT": "Hai problemi ad accedere?",
    "LEARN_MORE": "Maggiori informazioni su 2FA",
    "HELP_MODAL": {
      "TITLE": "Aiuto Autenticazione A Due Fattori",
      "AUTHENTICATOR_TITLE": "Utilizzando un'app di autenticazione",
      "AUTHENTICATOR_DESC": "Apri la tua app di autenticazione (Google Authenticator, Authy, ecc.) e inserisci il codice a 6 cifre mostrato per il tuo account.",
      "BACKUP_TITLE": "Utilizzando un Codice di Backup",
      "BACKUP_DESC": "Se non hai accesso alla tua app di autenticazione, puoi usare uno dei codici di backup salvati durante la configurazione 2FA. Ogni codice può essere utilizzato una sola volta.",
      "CONTACT_TITLE": "Serve Più Aiuto?",
      "CONTACT_DESC_CLOUD": "Se hai perso l'accesso sia alla tua app di autenticazione che ai codici di backup, contatta il supporto di Chatwoot per ricevere assistenza.",
      "CONTACT_DESC_SELF_HOSTED": "Se hai perso l'accesso sia alla tua app di autenticazione che ai codici di backup, contatta il tuo amministratore per ricevere assistenza."
    },
    "VERIFICATION_FAILED": "Verifica non riuscita. Riprova."
  }
}
